/* ASSETS  */
// import boutonLire from 'assets/img/bouton_lire.png';
// import boutonLireHoover from 'assets/img/bouton_lire_hoover_pink.png';
import boutonRegarder from 'assets/img/bouton_regarder.png';
import boutonRegarderHoover from 'assets/img/bouton_regarder_hoover_pink.png';
import boutonCoeur from 'assets/img/bouton_coeur.png';
import boutonCoeurHoover from 'assets/img/bouton_coeur_hoover_pink.png';
import homeIconBlack from 'assets/img/home-icon-black.png';

import blockBlancFakeChoiceSmall from 'assets/img/bloc_blanc_fakechoice_small.png';
import blockBlancFakeChoiceMedium from 'assets/img/bloc_blanc_fakechoice_medium.png';

/* FOREGROUND */
import backpack from 'assets/img/journey/senait/backpack.png';
import handImage from 'assets/img/journey/senait/hand.png';
import hugImage from 'assets/img/journey/senait/hug.png';
import epilogue_silhouette from 'assets/img/journey/senait/silhouette_2.png';
// import main_chute from 'assets/img/journey/senait/main_chute.png';
import bateau_pneumatique from 'assets/img/journey/senait/parcours_1_senait_bateau_penumatique.png';
import illu_viol from 'assets/img/journey/senait/parcours_1_senait_viol.png';

/* BACKGROUND */
import baseBackgroundImg from 'assets/img/home-background-min.jpg';
import backgroundPink from 'assets/img/backgound_pink.jpg';
import backgroundSequence1 from 'assets/img/journey/senait/1_WW6WR6-min.jpg';
import backgroundSequence2 from 'assets/img/journey/senait/2_HR912C_retouche-min.jpg';
import backgroundSequence3 from 'assets/img/journey/senait/3_P22F8N.jpg';
import backgroundSequence4 from 'assets/img/journey/senait/Senait_portrait-min.png';
import mountainBackground from 'assets/img/journey/senait/4_2C3FTG0-min.jpg';
// import backgroundMarket from 'assets/img/journey/senait/5_B8M52J_ok-min.jpg';
import desertImage from 'assets/img/journey/senait/6_W7XH55-min.jpg';
// import darkWindow from 'assets/img/journey/senait/11_2B2609R-min.jpg';
import girlsWalking from 'assets/img/journey/senait/7_1692344854-min.jpg';
import greenSkirt from 'assets/img/journey/senait/8_X5B8E-min.jpg';
import campSoudan from 'assets/img/journey/senait/9_M52BJ1-min.jpg';
// import batimentRoute from 'assets/img/journey/senait/10_BGRY4F-min.jpg';
import beach from 'assets/img/journey/senait/12_86gI_q3g-min.jpeg';
// import medecinBateau from 'assets/img/journey/senait/13_ENN0F8-min.jpg';
import refugee from 'assets/img/journey/senait/14_2D38X5R-min.jpg';
// import phoneBooth from 'assets/img/journey/senait/15_DbeBw0Vg-min.jpeg';
import parcMaximilien from 'assets/img/journey/senait/16_KoninklijkCircus_17_DSC09329_KristofVadino-min.jpg';
import porteEtLit from 'assets/img/journey/senait/17_PPEW4N-min.jpg';
// import pousette from 'assets/img/journey/senait/18_180219caritas_AM258-min.jpg';
import handsBehindWindow from 'assets/img/journey/senait/19_E92112-min.jpg';
// import cuisineLegume from 'assets/img/journey/senait/20_IMG_0113-min.jpg';
import cuisineLegume from 'assets/img/journey/senait/FOTO_vrienden_handen.jpg';
import paperWork from 'assets/img/journey/senait/21_0B2AuC-g-min.jpg';

/* MAPS */
// import map1 from 'assets/img/journey/senait/NL_parcours_1_carte_1.png';
import map2 from 'assets/img/journey/senait/NL_parcours_1_carte_2.png';
import map3 from 'assets/img/journey/senait/NL_parcours_1_carte_3.png';
// import map4 from 'assets/img/journey/senait/NL_parcours_1_carte_4.png';
import map5 from 'assets/img/journey/senait/NL_parcours_1_carte_5.png';
import map6 from 'assets/img/journey/senait/NL_parcours_1_carte_6.png';

// import mapIncoherence1 from 'assets/img/journey/senait/ecran_1_je_decide_NL.png';
import mapIncoherence2 from 'assets/img/journey/senait/ecran_2_je_rejoins_NL.png';

/* sounds */
import soundIntro from 'assets/sounds/senait_nl/SENAIT_NL_INTRO.mp3';
import SENAIT_JUNIOR_FR_SEQ01 from 'assets/sounds/senait_junior_fr/EP01_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ02 from 'assets/sounds/senait_junior_fr/EP02_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ03 from 'assets/sounds/senait_junior_fr/EP03_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ04 from 'assets/sounds/senait_junior_fr/EP04_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ05 from 'assets/sounds/senait_junior_fr/EP05_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ06 from 'assets/sounds/senait_junior_fr/EP06_ERYTHREE.mp3';

// import SENAIT_FR_SEQ07 from 'assets/sounds/senait_nl/SENAIT_NL_SEQ07.mp3';

import SENAIT_JUNIOR_FR_SEQ08 from 'assets/sounds/senait_junior_fr/EP08_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ09 from 'assets/sounds/senait_junior_fr/EP09_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ10 from 'assets/sounds/senait_junior_fr/EP10_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ11 from 'assets/sounds/senait_junior_fr/EP11_ERYTHREE.mp3';

// import SENAIT_FR_SEQ12 from 'assets/sounds/senait_nl/SENAIT_NL_SEQ12.mp3';
// import SENAIT_FR_SEQ13 from 'assets/sounds/senait_nl/SENAIT_NL_SEQ13.mp3';

import SENAIT_JUNIOR_FR_SEQ14 from 'assets/sounds/senait_junior_fr/EP14_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ15 from 'assets/sounds/senait_junior_fr/EP15_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ16 from 'assets/sounds/senait_junior_fr/EP16_ERYTHREE.mp3';

// import SENAIT_FR_SEQ17 from 'assets/sounds/senait_nl/SENAIT_NL_SEQ17.mp3';

import SENAIT_JUNIOR_FR_SEQ18 from 'assets/sounds/senait_junior_fr/EP18_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ19 from 'assets/sounds/senait_junior_fr/EP19_ERYTHREE.mp3';

// import SENAIT_FR_SEQ20 from 'assets/sounds/senait_nl/SENAIT_NL_SEQ20.mp3';

import SENAIT_JUNIOR_FR_SEQ21 from 'assets/sounds/senait_junior_fr/EP21_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ22 from 'assets/sounds/senait_junior_fr/EP22_ERYTHREE.mp3';
import SENAIT_JUNIOR_FR_SEQ23 from 'assets/sounds/senait_junior_fr/EP23_ERYTHREE.mp3';

// import SENAIT_FR_EPILOGUE1 from 'assets/sounds/senait_nl/SENAIT_NL_EPILOG1.mp3';
// import SENAIT_FR_EPILOGUE_MILITAIRE from 'assets/sounds/senait_nl/SENAIT_NL_EPILOG2.mp3';
// import SENAIT_FR_EPILOGUE_3 from 'assets/sounds/senait_nl/SENAIT_NL_EPILOG3.mp3';
// import SENAIT_FR_EPILOGUE_FINAL1 from 'assets/sounds/senait_nl/SENAIT_NL_EPILOGFIN1.mp3';
// import SENAIT_FR_EPILOGUE_FINAL2 from 'assets/sounds/senait_nl/SENAIT_NL_EPILOGFIN2.mp3';

// import blocNoir from 'assets/img/bloc_noir-min.png';
// import blocNoirHover from 'assets/img/block_noir_hoover-min.png';

import PhylactereAlone from 'assets/img/journey/senait/phylactere_pas_toute_seule_NL.png';
import PhylactereMaman from 'assets/img/journey/senait/phylactere_maman_NL.png';

import { getYoutubeIframe } from "./utils";


const colors = {
  // violet: '#5A36E4',
  pink: '#ff8080',
};

const choiceButtonStyle = { marginLeft: 'auto', marginRight: 'auto', marginTop: 20, padding: '30px!important', minHeight: 100, maxWidth: 250, color: 'white' };

// const otherChoiceButtonStyle = {
//   ...choiceButtonStyle,
//   fontSize: '1.5rem!important',
//   fontWeight: '700!important',
//   color: 'black!important',
//   backgroundImage: `url(${blockBlancFakeChoiceSmall})!important`,
//   maxWidth: 200,
//   '&:hover': { textDecoration: 'underline' },
// };

const base_choice_style = {
  containerStyle: {
    backgroundColor: 'white',
    color: 'black',
  },
  fixedImageBackground: backgroundSequence4,
  fixedImageBackgroundStyle: {
    backgroundSize: '35% auto',
    backgroundPosition: '95% center',
  },

  homeIcon: homeIconBlack,
  homeHoverIcon: homeIconBlack,

  contentStyle: {
    width: '50%',
    maxWidth: '1150px',
    marginLeft: '10%',
  },
};

const epilogeAnimationTiming = 2500;
// const epilogeSoundAdditionalDelay = 1500;
const base_epilogue = {
  type: 'epilogue',
  background: { src: backgroundPink },
  foreground: {
    src: epilogue_silhouette,
    // style: { height: '80vh', position: 'relative', top: '20vh', left: '-10vw', opacity: 1, transition: 'transform linear', transform: 'scale(1)', transformOrigin: '27.5% 65.1%' },
    style: {
      height: '80vh',
      position: 'relative',
      top: '20vh',
      left: '-10vw',
      opacity: 0,
      animationFillMode: 'forwards',
      animationTimingFunction: 'linear',
      transform: 'scale(.8)',
      transformOrigin: '27.5% 65.1%',
    },

    animations: [
      // { delay: 50, style: { transitionDuration: '2450ms', transform: 'scale(.8) translateY(-5vh) translateX(15vh)' } },
      { delay: 250, style: { animationName: 'opacityNoneToFull', animationDuration: `${epilogeAnimationTiming}ms` } },
    ],
  },
};

export const senait_junior_nl = {
  description: {
    name: 'Senait',
    age: '13',
    city: 'Quala',
    country: 'Eritrea',
    text: 'Mijn voornaam betekent “veel geluk” en ik vind dat dat goed bij me past. Ik ben heel positief, net als mijn moeder. Ik heb ook een stevig karakter, net als mijn vader. In Eritrea kan je daarmee in de problemen komen, dus heeft mijn moeder me verteld dat ik dat “geluk” nog nodig zal hebben in mijn leven.',
    sound: soundIntro,
  },

  additionalLoad: [
    { type: 'img', src: PhylactereAlone },
    { type: 'img', src: PhylactereMaman },
    { type: 'img', src: backgroundPink },
    { type: 'img', src: backpack },
    { type: 'img', src: handImage },
    { type: 'img', src: hugImage },
    { type: 'img', src: epilogue_silhouette },
    // { type: 'img', src: main_chute },
    { type: 'img', src: bateau_pneumatique },
    { type: 'img', src: illu_viol },
    { type: 'img', src: blockBlancFakeChoiceSmall },
    { type: 'img', src: blockBlancFakeChoiceMedium },
  ],
  skipAutoNextStep: true,
  soundsInLoop: true,
  steps: [
    {
      id: 'SENAIT 01',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ01,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Mijn moeder heeft een winkeltje en ik help haar na schooltijd. ', delay: 1100 },
      //   { type: 'text', text: 'Het is zwaar, maar we helpen elkaar. ', delay: 3950 },
      //   { type: 'text', text: 'Het was makkelijker toen mijn vader er nog was. ', delay: 2140 },
      //   { type: 'text', text: 'Hij was leerkracht, maar hij werd verklikt omdat hij in de klas te kritisch was tegenover het beleid van de regering. ', delay: 2840 },
      //   { type: 'text', text: 'De politie heeft toen ontdekt dat hij met activistische vrienden in ballingschap correspondeerde ', delay: 6130 },
      //   { type: 'text', text: 'en heeft hem toen aangehouden.', delay: 5840 },
      //   { type: 'text', text: '', delay: 3100 },
      //   { type: 'goToNext', delay: 1970 },
      // ],
      nextStepId: 'SENAIT 02',
      background: {
        src: backgroundSequence1,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '27070ms' } }],
      },
      textBackgroundColor: 'transparent',
    },
    {
      id: 'SENAIT 02',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ02,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Vorige week heeft de politie mijn moeder en mij opgeroepen, omdat we bezoek hadden gekregen van mijn oom.', delay: 1080 },
      //   { type: 'text', text: 'Een buurman had dat doorverteld. ', delay: 5080 },
      //   { type: 'text', text: 'Mijn oom is na de arrestatie van mijn vader uit Eritrea gevlucht en ijvert nu voor zijn vrijlating. ', delay: 2030 },
      //   { type: 'text', text: 'De politie beschuldigt ons ervan samen te werken met die \u2018verraders\u2019. ', delay: 5970 },
      //   { type: 'text', text: 'Ik werd naar huis gestuurd op voorwaarde dat ik mijn oom zou aangeven als hij ons weer zou bezoeken.', delay: 4040 },
      //   { type: 'text', text: 'Mijn moeder zit daar nog altijd. ', delay: 6030 },
      //   { type: 'text', text: '', delay: 2890 },
      //   { type: 'goToNext', delay: 2060 },
      // ],
      nextStepId: 'SENAIT 03',
      background: {
        src: backgroundSequence2,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '29000ms' } }],
      },
      textBackgroundColor: 'transparent',
    },
    {
      id: 'SENAIT 03',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ03,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Wat moet ik doen? ', delay: 1240 },
      //   { type: 'text', text: 'Ik kan mijn oom niet waarschuwen, want de telefoon wordt afgeluisterd. ', delay: 2760 },
      //   { type: 'text', text: 'Er rijden agenten rond die me in de gaten houden. ', delay: 3150 },
      //   { type: 'text', text: 'Ik ben bang, ik weet niet wat ik moet doen.', delay: 2090 },
      //   { type: 'text', text: 'Mijn buurmeisje Mehret wil samen met twee vriendinnen wegvluchten uit Eritrea. ', delay: 3000 },
      //   { type: 'text', text: 'Ik heb er al aan gedacht met hen mee te gaan, maar dan denk ik: ', delay: 4810 },
      //   { type: 'text', text: 'het is verboden, de grenswachten mogen zelfs schieten ', delay: 3120 },
      //   { type: 'text', text: 'en als je weg bent uit Eritrea, kun je nooit meer terugkomen. ', delay: 3950 },
      //   { type: 'text', text: 'Maar ik zou wel mijn oom kunnen waarschuwen als ik de grens over ben geraakt. ', delay: 3930 },
      //   { type: 'text', text: 'Het zou veiliger zijn als ik de regio gewoon zou verlaten. ', delay: 4020 },
      //   { type: 'text', text: 'Ik heb een tante in het noorden van Eritrea, maar dat is ver en ik ben bang dat het verdacht zou lijken. ', delay: 3940 },
      //   { type: 'text', text: '', delay: 7040 },
      //   { type: 'goToNext', delay: 1990 },
      // ],
      nextStepId: 'info1',
      background: {
        src: backgroundSequence3,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scaleDown20', animationDuration: '45040ms' } }],
      },
    },
    {
      ...base_choice_style,
      id: 'info1',
      type: 'info',

      contentText:
        'Wat zou jij doen in mijn plaats?&thinsp;Zou je je verschuilen in het <span class="background-underlined large">noorden van Eritrea</span>, zou je <span class="background-underlined large">met Mehret</span> uit Eritrea vluchten of zou je <span class="background-underlined large">afwachten</span>?',
      actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
      actions: [
        // {
        //   type: 'button',
        //   key: 'button-watch-1',
        //   text: 'Ik bekijk het interview met Dawit, ervaringsdeskundige uit Eritrea',
        //   buttonStyle: { '&:hover': { color: colors.pink } },
        //   icon: boutonRegarder,
        //   iconHover: boutonRegarderHoover,
        //   action: 'openDialog',
        //   dialogContent: {
        //     transition: 'slideUp',
        //     type: 'video',
        //     videoIframe: getYoutubeIframe('E8WmdaxemAU'),
        //   },
        // },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Ik beluister de getuigenis van het vluchtverhaal van Sham',
          buttonStyle: { '&:hover': { color: colors.pink } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('FOCjTpsmAFY'),
          },
        },
        // {
        //   type: 'button',
        //   key: 'button-read',
        //   text: 'Ik lees het rapport van Amnesty International over Eritrea',
        //   buttonStyle: { '&:hover': { color: colors.pink } },
        //   icon: boutonLire,
        //   iconHover: boutonLireHoover,
        //   action: 'openDialog',
        //   dialogContent: {
        //     transition: 'slideUp',
        //     backgroundImage: backgroundPink,
        //     type: 'text',
        //     title: "Amnesty International rapport over Eritrea<br/><span class='subtitle'>(samenvatting van rapport 2020)</span>",
        //     text: "<span class='inline-title'>Willekeurige detentie en gedwongen verdwijningen</span>Honderden mensen die kritisch tegenover de regering staan worden nog steeds willekeurig vastgehouden, zonder aanklacht of proces en krijgen nog steeds geen toestemming om hun familie en advocaten te spreken.<span class='inline-title'>Vrijheid van meningsuiting</span>In 2020 was Eritrea het meest gecensureerde land ter wereld en zaten er volgens het Comité ter Bescherming van Journalisten meer journalisten in de gevangenis dan in gelijk welk ander land.<span class='inline-title'>Gedwongen arbeid</span>De verplichte nationale dienstplicht voor onbepaalde duur wordt nog steeds afgedwongen. Duizenden blijven voor onbepaalde duur dienstplichtig. Velen van hen hebben al tientallen jaren dienst gedaan. De regering gebruikt de dienstplichtigen om te werken aan infrastructuurprojecten (wegen, landbouw...).<span class='inline-title'>Vluchtelingen</span>Duizenden Eritreeërs zijn het land ontvlucht. Zij worden onderweg nog steeds geconfronteerd met ernstige schendingen van de mensenrechten, vooral in Libië, waar velen worden onderworpen aan opsluiting, ontvoering, seksueel misbruik, marteling en andere vormen van mishandeling.<br/><br/>Dit is een samenvatting van het <a href='https://www.amnesty.org/fr/countries/africa/eritrea/report-eritrea/' target='_blank'>2020 Amnesty rapport over Eritrea</a>.",
        //   },
        // },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.pink },
      },
      nextButtonText: 'Neem een beslissing >',
      nextStepId: 'choice1',
    },
    {
      id: 'choice1',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Wat zou jij doen in mijn plaats?&thinsp;Zou je je verschuilen in het <span class="background-underlined large">noorden van Eritrea</span>, zou je <span class="background-underlined large">met Mehret</span> uit Eritrea vluchten of zou je <span class="background-underlined large">afwachten</span>?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Je verschuilen in het noorden van Eritrea ',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Weet je het zeker?</span><br/>Het is een lange reis om op mijn leeftijd in je eentje te maken.',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 09',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Met Mehret uit Eritrea vluchten',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Weet je het zeker?</span><br/>Als ik Eritrea verlaat, kan ik misschien nooit meer terugkomen.',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 04',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-3',
          text: 'Wachten',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: '<span class="background-underlined large">Weet je het zeker?</span><br/>Misschien zal ik dan mijn eigen oom moeten aangeven als hij nog eens komt!',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 09',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    //5
    {
      id: 'SENAIT 04',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ04,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Mehret wilde eerst niet dat ik met haar meeging, omdat ik te jong ben.', delay: 1050 },
      //   { type: 'text', text: 'Maar ik drong aan en uiteindelijk vond ze het goed.', delay: 3950 },
      //   { type: 'text', text: 'Nu moeten we in het geheim ons vertrek voorbereiden. ', delay: 3020 },
      //   { type: 'text', text: 'Als onze families het te weten komen, zullen ze ons tegenhouden, ', delay: 3000 },
      //   { type: 'text', text: 'omdat het risico te groot is dat de grenswachten ons doden. ', delay: 3150 },
      //   { type: 'text', text: 'We moeten 2 dagen \u2018s nachts door de bergen trekken en ons overdag verstoppen. ', delay: 3880 },
      //   { type: 'text', text: '', delay: 5020 },
      //   { type: 'goToNext', delay: 930 },
      // ],
      background: {
        src: baseBackgroundImg,
        // style: { },
        // animations: [
        //   { delay: 1000, style: { transitionDuration: '2000ms', left: '0%' } },
        //   { delay: 2000, style: { transitionDuration: '2000ms', height: '120%', top: '-10%', width: '140%', left: '-40%' } },
        // ],
      },
      foreground: {
        src: backpack,
        style: { height: '68%', position: 'relative', top: '-5%', opacity: 0 }, // transition: 'transform linear, opacity linear'
        animations: [
          { delay: 5000, style: { animationName: 'opacityNoneToFull, scale100To74', animationDuration: '13020ms' } }, //, transitionDuration: '11020ms', transform: 'scale(0.74)', opacity: 1
          { delay: 13020, style: { animationName: 'opacityFullToNone, scale74To50', animationDuration: '6000ms' } }, //, transitionDuration: '10170ms', transform: 'scale(0.50)', opacity: 0
        ],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'SENAIT 05',
    },
    {
      id: 'SENAIT 05',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ05,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'We zijn bij valavond vertrokken op de plaats van afspraak ', delay: 2060 },
      //   { type: 'text', text: 'die onze smokkelaar had opgegeven. ', delay: 2180 },
      //   { type: 'text', text: 'Nu is het pikdonker. ', delay: 2880 },
      //   { type: 'text', text: 'Je ziet bijna niet waar je stapt. ', delay: 2000 },
      //   { type: 'text', text: 'Ik glijd uit op een steen en verzwik mijn enkel.', delay: 1040 },
      //   { type: 'text', text: 'Ik kan niet meer stappen. ', delay: 4890 },
      //   { type: 'text', text: 'Mehret maakt een knoop in haar omslagdoek en wil me op haar rug dragen, ', delay: 1180 },
      //   { type: 'text', text: 'maar de smokkelaar trekt hem af: ', delay: 3950 },
      //   { type: 'text', text: 'hij zegt dat ik verloren ben en dat zij ook gearresteerd zal worden. ', delay: 2830 },
      //   { type: 'text', text: 'Mehret bedreigt hem, zegt dat ze hem zal aangeven als ze aangehouden wordt.', delay: 4990 },
      //   { type: 'text', text: 'Hij slaat haar en sleurt haar mee. ', delay: 4150 },
      //   { type: 'text', text: 'Tegen mij zegt hij dat ik terug moet naar de plaats van afspraak. ', delay: 2920 },
      //   { type: 'text', text: 'Ik ben doodsbang dat ze me zullen achterlaten en dat de grenswachten me zullen vinden, ', delay: 3140 },
      //   { type: 'text', text: 'maar ik kan niet iedereen in gevaar brengen. ', delay: 4810 },
      //   { type: 'text', text: '', delay: 2220 },
      //   { type: 'goToNext', delay: 2780 },
      // ],
      background: {
        src: mountainBackground,
        style: { transformOrigin: 'center 80%' },
        // animations: [
        //   { delay: 50, style: { transitionDuration: '36010ms', transform: 'scale(1.5)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
        animations: [{ delay: 4040, style: { animationName: 'scale100To150', animationDuration: '48020ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' },
        animations: [
          { delay: 50, style: { animationName: 'opacityNoneTo60', animationDuration: '8030ms' } }, //transitionDuration: '8030ms', opacity: 0.6
          { delay: 8030, style: { animationName: 'opacity60ToFull', animationDuration: '40010ms' } }, //transitionDuration: '28010ms', opacity: 1
        ],
      },
      foreground: {
        src: handImage,
        style: { height: '70%', position: 'relative', top: '-6%', opacity: 0, transform: 'scale(0.75) translateX(-10vh)' }, //transform: 'scale(0.75) translateX(-10vh)',transition: 'transform linear, opacity linear, left linear', transformOrigin: 'center'
        animations: [
          { delay: 20020, style: { transform: 'scale(0.75) translateX(-10vh)', animationName: 'opacityNoneToFull', animationDuration: '0ms' } }, //transitionDuration: '0ms', transform: 'scale(0.75) translateX(-10vh)', opacity: 1
          { delay: 50, style: { opacity: 1, animationName: 'handAnimationPart1', animationDuration: '5100ms' } }, // transform: 'translateX(1vh)', opacity: 1
          { delay: 5100, style: { animationDuration: '3020ms', animationName: 'handAnimationPart2, opacityFullToNone' } }, //transform: ' translateX(10vh)', opacity: 0
        ],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'info_GYUI',
    },
    {
      ...base_choice_style,
      id: 'info_GYUI',
      type: 'info',

      contentText: 'Wat zou jij doen in mijn plaats?<br/>Vraag je aan <span class="background-underlined very-large">Mehret om je niet achter te laten</span>? Of doe je <span class="background-underlined large">wat de smokkelaar zegt</span> en keer je alleen terug naar de plaats van afspraak?',
      actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
      actions: [
        {
          type: 'button',
          key: 'button-ask',
          text: 'Ik vraag aan Senait wat haar hart zegt',
          buttonStyle: { '&:hover': { color: colors.pink } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereAlone,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.pink },
      },
      nextButtonText: 'Neem een beslissing >',
      nextStepId: 'choice2',
    },
    {
      id: 'choice2',
      type: 'choice',

      ...base_choice_style,
      contentText: 'Wat zou jij doen in mijn plaats?<br/>Vraag je aan <span class="background-underlined very-large">Mehret om je niet achter te laten</span>? Of doe je <span class="background-underlined large">wat de smokkelaar zegt</span> en keer je alleen terug naar de plaats van afspraak?',

      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'Mehret smeken om me niet achter te laten',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 06A',
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Terugkeren naar de plaats van afspraak',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 06B',
        },
      ],
    },
    {
      id: 'SENAIT 06A',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ06,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Ik smeek Mehret en ze keert terug', delay: 2050 },
      //   { type: 'text', text: 'De jongen laat ons achter en gaat met de anderen verder.', delay: 2960 },
      //   { type: 'text', text: 'Opeens horen we in de verte schoten.', delay: 3130 },
      //   { type: 'text', text: 'We gaan op de grond liggen. ', delay: 2940 },
      //   { type: 'text', text: 'In de verte zien we 3 silhouetten die door de velden lopen en op wie geschoten wordt. ', delay: 2930 },
      //   { type: 'text', text: 'Ik zie er \u00e9\u00e9n vallen', delay: 5000 },
      //   { type: 'text', text: 'Dit hadden wij kunnen zijn. ', delay: 2000 },
      //   { type: 'text', text: 'We zijn in shock. ', delay: 2040 },
      //   { type: 'text', text: 'We zijn helemaal alleen, verder is er niets. We weten de weg naar Ethiopi\u00eb niet. ', delay: 1960 },
      //   { type: 'text', text: 'Ik schrik op bij elk geluid ...', delay: 5020 },
      //   { type: 'text', text: '', delay: 3010 },
      //   { type: 'goToNext', delay: 120 },
      // ],
      background: { src: baseBackgroundImg },
      foreground: {
        src: hugImage,
        style: { height: '70%', position: 'relative', top: '-6%', opacity: 0, transformOrigin: 'center top' }, //transition: 'transform linear, opacity linear',

        animations: [
          // { delay: 2950, style: { animationDuration: '50ms', animationName:'opacityNoneToFull', } }, //transform: 'scale(1)', opacity: 0
          { delay: 3000, style: { animationDuration: '2000ms', animationName: ' opacityNoneToFull' } }, //scale20transform: 'scale(1.2)', ,opacity: 1
          { delay: 2000, style: { animationDuration: '3500ms', animationName: ' opacityFullToNone' } }, //scaleDown20, //,transform: 'scale(1)', opacity: 0
        ],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'map2',
    },
    //10
    {
      id: 'SENAIT 06B',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ06,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Opeens horen we schoten. ', delay: 10 },
      //   { type: 'text', text: 'Ik panikeer en smeek Mehret om me niet achter te laten. ', delay: 2040 },
      //   { type: 'text', text: 'Ze keert terug. ', delay: 3970 },
      //   { type: 'text', text: 'De jongen laat ons achter en gaat verder met de anderen. ', delay: 1120 },
      //   { type: 'text', text: 'We gaan op de grond liggen.', delay: 3070 },
      //   { type: 'text', text: 'In de verte zien we 3 silhouetten die door de velden lopen en op wie geschoten wordt. ', delay: 2000 },
      //   { type: 'text', text: 'Ik zie er een vallen. ', delay: 5790 },
      //   { type: 'text', text: 'Dit hadden wij kunnen zijn.', delay: 1190 },
      //   { type: 'text', text: 'We zijn in shock. ', delay: 1990 },
      //   { type: 'text', text: 'We zijn helemaal alleen, verder is er niets. We weten de weg naar Ethiopi\u00eb niet.', delay: 1990 },
      //   { type: 'text', text: 'Ik schrik op bij elk geluid ... ', delay: 5830 },
      //   { type: 'text', text: '', delay: 2000 },
      //   { type: 'goToNext', delay: 30 },
      // ],
      background: { src: baseBackgroundImg },
      foreground: {
        src: hugImage,
        style: { height: '70%', position: 'relative', top: '-6%', opacity: 0, transformOrigin: 'center top' }, //transition: 'transform linear, opacity linear',
        animations: [
          // { delay: 8140, style: { transitionDuration: '50ms', transform: 'scale(1)', opacity: 0 } },
          { delay: 6020, style: { animationDuration: '3000ms', animationName: 'opacityNoneToFull' } }, //scale20//,transform: 'scale(1.2)', opacity: 1
          { delay: 3000, style: { animationDuration: '3000ms', opacity: 1, animationName: ' opacityFullToNone' } }, //scaleDown20 transform: 'scale(1)', opacity: 0
        ],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'map2',
    },
    // {
    //   id: 'map1',
    //   type: 'map',
    //   background: baseBackgroundImg,
    //   mapImage: map1,
    //   mapContainerClass: 'cursor-gray',
    //   nextStepDelay: 3500,
    //   nextStepId: 'SENAIT 07',
    // },
    // {
    //   id: 'SENAIT 07',
    //   type: 'sequence',
    //   // sound: SENAIT_FR_SEQ07,
    //   // sound_delay: 50,
    //   // sequence: [
    //   //   { type: 'text', text: 'We hebben de vriendinnen van Mehret gevonden', delay: 1030 },
    //   //   { type: 'text', text: 'en we zijn in Karthoem in Soedan geraakt. ', delay: 2090 },
    //   //   { type: 'text', text: 'Hier heb ik mijn oom kunnen bellen om hem te waarschuwen ', delay: 2960 },
    //   //   { type: 'text', text: 'en ik heb ook gehoord dat mijn moeder vrijgelaten is.', delay: 3000 },
    //   //   { type: 'text', text: 'Ik werk als huishoudhulp bij een gezin. ', delay: 3010 },
    //   //   { type: 'text', text: 'Ik kan niet naar school gaan, maar gelukkig behandelen mijn bazen me goed, ', delay: 2090 },
    //   //   { type: 'text', text: 'ook al word ik niet goed betaald.', delay: 4040 },
    //   //   { type: 'text', text: 'Mehret heeft minder geluk: haar baas slaat haar. ', delay: 2880 },
    //   //   { type: 'text', text: 'We kunnen geen klacht indienen bij de politie, want we hebben geen papieren. ', delay: 3900 },
    //   //   { type: 'text', text: 'Ze kunnen ons zomaar op straat aanhouden en terugsturen naar Eritrea. ', delay: 3200 },
    //   //   { type: 'text', text: 'We voelen ons niet veilig. ', delay: 4800 },
    //   //   { type: 'text', text: 'De meisjes willen liever naar Libi\u00eb en dan naar Europa. ', delay: 2010 },
    //   //   { type: 'text', text: 'Ik weet dat dat een gevaarlijke reis is, ', delay: 4000 },
    //   //   { type: 'text', text: 'maar ik wil hier niet alleen en zonder hun bescherming achterblijven. ', delay: 2000 },
    //   //   { type: 'text', text: '', delay: 7020 },
    //   //   { type: 'goToNext', delay: 1970 },
    //   // ],
    //   background: {
    //     src: backgroundMarket,
    //     style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
    //     animations: [
    //       // { delay: 50, style: { transitionDuration: '23080ms', transform: 'scale(1.2)' } },
    //       { delay: 50, style: { animationName: 'scale20', animationDuration: '50000ms' } },
    //     ],
    //   },

    //   nextStepId: 'infoSoudanOuEurope',
    //   textBackgroundColor: '#1D1003',
    // },
    // {
    //   ...base_choice_style,
    //   id: 'infoSoudanOuEurope',
    //   type: 'info',

    //   contentText:
    //     'Wat een dilemma! Wat zou jij doen? Zou je je <span class="background-underlined large">vriendinnen volgen</span> naar Europa? Of zou je <span class="background-underlined medium">in Soedan bli</span>jven?',
    //   actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
    //   actions: [
    //     {
    //       type: 'button',
    //       key: 'button-watch-1',
    //       text: 'Ik beluister de getuigenis van een Eritrese jongere die via Khartoem vluchtte',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonRegarder,
    //       iconHover: boutonRegarderHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         type: 'video',
    //         videoIframe: getYoutubeIframe('DuOqrx7cg4g'),
    //       },
    //     },
    //   ],
    //   nextButtonStyle: {
    //     '&:hover': { color: colors.pink },
    //   },
    //   nextButtonText: 'Neem een beslissing >',
    //   nextStepId: 'choiceSoudanOuEurope',
    // },
    // {
    //   ...base_choice_style,
    //   id: 'choiceSoudanOuEurope',
    //   type: 'choice',

    //   contentText:
    //     'Wat een dilemma! Wat zou jij doen? Zou je je <span class="background-underlined large">vriendinnen volgen</span> naar Europa? Of zou je <span class="background-underlined medium">in Soedan bli</span>jven?',
    //   choices: [
    //     {
    //       type: 'button',
    //       key: 'button-1',
    //       text: 'In Karthoem blijven',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'epilogue_soudan',
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-2',
    //       text: 'Naar Europa gaan',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'SENAIT 08',
    //     },
    //   ],
    // },
    //15
    // {
    //   id: 'epilogue_soudan',

    //   ...base_epilogue,

    //   // sound: SENAIT_FR_EPILOGUE1,
    //   // sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
    //   sequence: [
    //     {
    //       delay: epilogeAnimationTiming,
    //       title: 'Dit is hoe mijn leven eruitziet in Soedan...',
    //       // text: 'Ik werk nog altijd als huishoudhulpje. Ik heb nieuwe vrienden gevonden onder de Eritreeërs die hier wonen en ik voel me minder alleen, ook al ben ik maar een dag per week vrij om met hen af te spreken.<br/><br/>Omdat we geen papieren hebben, zijn we soms overgeleverd aan mensen die van ons profiteren of kunnen we gearresteerd worden. Ik voel me dus niet veilig, maar we steunen elkaar wel.<br/><br/>Het is zwaar dat ik niet van een beter leven kan dromen, dat ik geen huishoudhulp meer moet zijn, maar ik ben ook blij dat ik mijn familie kan helpen en wat geld opzij kan zetten om naar hen op te sturen.',
    //       textStyle: { left: '45vw' },
    //     },
    //   ],
    //   // nextStepId: 'other_choices',
    //   nextStepId: "-1",
    // },
    // {
    //   id: 'other_choices',
    //   type: 'choice',

    //   ...base_choice_style,

    //   fixedImageBackground: baseBackgroundImg,

    //   fixedImageBackgroundStyle: {
    //     backgroundSize: '100% 100%',
    //     backgroundPosition: 'center',
    //     zIndex: 0,
    //   },

    //   contentStyle: {
    //     width: '100%',
    //     maxWidth: '500px',
    //     marginLeft: 'auto',
    //     marginRight: 'auto',
    //     color: 'white',
    //     zIndex: 100,
    //   },
    //   contentTextStyle: {
    //     textTransform: 'none',
    //     textAlign: 'center',
    //   },
    //   contentText: 'Wil je weten wat er zou gebeurd zijn mocht je <span class="background-underlined large white">andere keuzes</span> hebben gemaakt?',

    //   choices: [
    //     {
    //       type: 'button',
    //       key: 'button-1',
    //       text: 'Ja, ik ga terug naar het begin van het parcours.',
    //       buttonStyle: otherChoiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'SENAIT 01',
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-2',
    //       text: 'Nee',
    //       buttonStyle: otherChoiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: '-1',
    //     },
    //   ],
    // },
    {
      id: 'SENAIT 08',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ08,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Al 9 dagen in de woestijn, met meer dan 100 mensen op elkaar gepakt in een vrachtwagen. ', delay: 3140 },
      //   { type: 'text', text: '9 dagen honger, warm, dorst \u2026 ', delay: 6040 },
      //   { type: 'text', text: 'vooral dorst ... ', delay: 4060 },
      //   { type: 'text', text: 'De twee bidons water per persoon zijn niet genoeg. ', delay: 1890 },
      //   { type: 'text', text: 'Vooral niet voor Mehret, die al dagen overgeeft. ', delay: 3060 },
      //   { type: 'text', text: 'Ze is zo zwak dat ze uit de vrachtwagen glijdt. ', delay: 3910 },
      //   { type: 'text', text: 'We kunnen haar nog maar net grijpen. We houden haar vast zodat ze niet meer valt.', delay: 3080 },
      //   { type: 'text', text: 'Ik vraag water aan de mensen \u2026 maar het is te laat, denk ik.', delay: 5000 },
      //   { type: 'text', text: 'Mehret beweegt niet meer. ', delay: 3990 },
      //   { type: 'text', text: 'Ik raak in paniek. Ik schud haar door elkaar. Het helpt niet.', delay: 2880 },
      //   { type: 'text', text: 'Ze sterft stilletjes, in mijn armen. ', delay: 5000 },
      //   { type: 'text', text: 'Ik wil schreeuwen.', delay: 3150 },
      //   { type: 'text', text: '', delay: 3030 },
      //   { type: 'goToNext', delay: 1860 },
      // ],
      background: {
        src: desertImage,
        // style: { transition: 'transform linear' }, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { transitionDuration: '20130ms', transform: 'scale(1.2)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],

        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scaleDown20', animationDuration: '20130ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' },
        animations: [{ delay: 50, style: { animationName: 'opacityNoneTo60', animationDuration: '20130ms' } }],
      },
      // foreground: {
      //   src: main_chute,
      //   style: { height: '70%', position: 'relative', opacity: 0, transition: 'transform linear, opacity linear', transformOrigin: 'center', transform: 'translate(-20%, 20%)' },
      //   animations: [
      //     { delay: 18210, style: { animationName: 'opacityNoneToFull', animationDuration: '2000ms' } },
      //     { delay: 2000, style: { opacity: 1, animationName: 'animationSenait08_A', animationDuration: '13790ms' } },
      //     { delay: 13790, style: { animationName: 'opacityFullToNone', animationDuration: '11000', transform: 'translate(20%, -40%)' } },
      //   ],
      // },

      // nextStepId: 'SENAIT 13',
      nextStepId: 'map lybie from soudan',
      textBackgroundColor: '#392223',
    },
    // {
    //   id: 'SENAIT 13',
    //   type: 'sequence',
    //   // sound: SENAIT_FR_SEQ13,
    //   // sound_delay: 50,
    //   // sequence: [
    //   //   { type: 'text', text: 'Ik weet niet waar ik ben \u2026 ', delay: 8080 },
    //   //   { type: 'text', text: 'Er is alleen maar woestijn \u2026', delay: 2030 },
    //   //   { type: 'text', text: 'Ik heb het gevoel dat ik niet meer leef, ik voel niets meer. ', delay: 2090 },
    //   //   { type: 'text', text: 'Ik ben niet bang meer om te sterven, ik wil gewoon dat het stopt. ', delay: 4030 },
    //   //   { type: 'text', text: 'We zijn gekidnapt door smokkelaars, iedereen die op de vrachtwagen zat. ', delay: 6770 },
    //   //   { type: 'text', text: 'Ze vragen \u20ac 3000 per persoon om vrijgelaten te worden. ', delay: 5060 },
    //   //   { type: 'text', text: 'Ze deden wat ze wilden met mij. ', delay: 4940 },
    //   //   { type: 'text', text: 'Ze hebben mijn moeder gebeld. Ze heeft alles gehoord. ', delay: 2030 },
    //   //   { type: 'text', text: 'Ze heeft gesmeekt om te stoppen, ze heeft beloofd dat ze zal betalen,', delay: 3140 },
    //   //   { type: 'text', text: 'dat ze een oom in Engeland zou bellen. ', delay: 4000 },
    //   //   { type: 'text', text: 'Dus laten ze me nu met rust. ', delay: 2930 },
    //   //   { type: 'text', text: 'Sommigen zitten hier al maanden, ', delay: 2930 },
    //   //   { type: 'text', text: 'ze wachten tot hun familie het geld heeft gevonden en heeft betaald. ', delay: 2150 },
    //   //   { type: 'text', text: 'We krijgen niet genoeg te eten en te drinken en sommige mensen zijn ziek. ', delay: 4000 },
    //   //   { type: 'text', text: 'Een meisje is zwanger. Ik bid maar dat het mij niet overkomt.', delay: 4970 },
    //   //   { type: 'text', text: '', delay: 45860 },
    //   //   { type: 'goToNext', delay: 3210 },
    //   // ],
    //   background: {
    //     src: darkWindow,
    //     // style: { transition: 'transform linear' },
    //     style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
    //     animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '34950ms' } }],
    //   },
    //   backgroundEffect: {
    //     style: { opacity: 0, backgroundColor: 'black', animationFillMode: 'forwards', animationTimingFunction: 'linear' },
    //     animations: [
    //       { delay: 50, style: { animationName: 'opacityNoneToFull', animationDuration: '34950ms' } },
    //       { delay: 34950, style: { animationName: 'opacityFullToNone', animationDuration: '37000ms' } },
    //     ],
    //   },
    //   foreground: {
    //     src: illu_viol,
    //     style: { height: '90vh', marginBottom: 'auto', objectPosition: 'right center', opacity: 0, transformOrigin: 'bottom center', animationTimingFunction: 'linear' },
    //     animations: [
    //       { delay: 28000, style: { animationName: 'opacityNoneToFull, scale100To107', animationDuration: '6000ms' } },
    //       { delay: 6000, style: { animationName: 'opacityFullToNone, scale107To120', animationDuration: '10000ms' } },
    //       // { delay: 11020, style: { transitionDuration: '10170ms', transform: 'scale(0.50)', opacity: 0 } },
    //     ],
    //   },
    //   nextStepId: 'SENAIT 14',
    // },
    {
      id: 'SENAIT 09',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ09,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Gelukkig is mijn moeder vrijgelaten en mijn oom niet meer teruggekomen. ', delay: 3000 },
      //   { type: 'text', text: 'De jaren gaan voorbij, ik ben nu 16. ', delay: 5000 },
      //   { type: 'text', text: 'Net als iedereen van mijn leeftijd zullen ze me deze zomer meenemen ', delay: 3180 },
      //   { type: 'text', text: 'naar het militaire kamp van Sawa. ', delay: 3860 },
      //   { type: 'text', text: 'Alleen al bij de gedachte lopen de rillingen over mijn rug', delay: 3040 },
      //   { type: 'text', text: 'Mijn vrienden hebben erover verteld.', delay: 4080 },
      //   { type: 'text', text: 'En omdat ik geen goeie leerling ben, zal ik na mijn legerdienst', delay: 2020 },
      //   { type: 'text', text: 'in het leger moeten blijven, als soldaat of voor openbare werken. ', delay: 3820 },
      //   { type: 'text', text: 'Misschien wel voor jaren. ', delay: 5010 },
      //   { type: 'text', text: 'Wat moet ik doen? ', delay: 2040 },
      //   { type: 'text', text: 'Me verstoppen en niet gaan?', delay: 1160 },
      //   { type: 'text', text: 'Mijn moeder heeft me dat afgeraden.', delay: 2820 },
      //   { type: 'text', text: 'Ze zegt dat het een verschrikkelijk leven is, je de hele tijd moeten verstoppen. ', delay: 2080 },
      //   { type: 'text', text: 'Ik kan ook trouwen en zwanger worden, net als de andere meisjes, zodat ik niet hoef te gaan? ', delay: 5030 },
      //   { type: 'text', text: 'Of het land verlaten?', delay: 5950 },
      //   { type: 'text', text: '', delay: 3020 },
      //   { type: 'goToNext', delay: 1130 },
      // ],
      background: {
        src: girlsWalking,
        style: { width: '120vw', position: 'relative', left: '-20vw' }, // transition: 'transform linear'
        animations: [
          { delay: 50, style: { animationDuration: '56240ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: 'transparent',
      // nextStepId: 'infoCampMilitaire',
      nextStepId: 'choice camp militaire',
    },
    //20
    // {
    //   ...base_choice_style,
    //   id: 'infoCampMilitaire',
    //   type: 'info',

    //   contentText:
    //     'Wat een dilemma! Wat zou jij doen in mijn plaats?<br/>Zou je naar het <span class="background-underlined medium">legerkamp</span> van Sawa gaan, zou je <span class="background-underlined medium">trouwen</span> of zou je <span class="background-underlined large">wegvluchten uit je land</span>?',
    //   actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
    //   actions: [
    //     {
    //       type: 'button',
    //       key: 'button-watch-1',
    //       text: 'Ik beluister de getuigenis van een jong meisje dat de militaire dienst is ontvlucht',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonRegarder,
    //       iconHover: boutonRegarderHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         type: 'video',
    //         videoIframe: getYoutubeIframe('-wdw2i3OLLk'),
    //       },
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-read',
    //       text: 'Ik lees een rapport over de nationale dienstplicht in Eritrea',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonLire,
    //       iconHover: boutonLireHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         backgroundImage: backgroundPink,
    //         type: 'text',
    //         title: "Ze onderwijzen ons niet, ze duwen ons in de slavernij<br/><span class='subtitle'>Rapport van Human Rights Watch over de nationale dienstplicht in Eritrea (samenvatting)</span>",
    //         text: "Sinds de oorlog met Ethiopië eind jaren negentig wordt een groot deel van de bevolking grotendeels gegijzeld via de nationale dienstplicht. Uit onderzoek van Human Rights Watch blijkt dat veel Eritreeërs hun hele werkzame leven in dienst van de regering doorbrengen, hetzij als militair, hetzij als burger.<br/><br/>De \"geen oorlog, geen vrede\"-situatie diende als excuus voor de Eritrese regering om alle middelbare scholieren naar het militaire kamp Sawa te dwingen om hun laatste jaar af te maken en een verplichte militaire training te volgen. Elk jaar worden duizenden jongeren, van wie sommigen nog kinderen zijn, met geweld vanuit hun woonplaats in het hele land naar Sawa gebracht.<br/><br/>In Sawa worden de studenten onderworpen aan mishandeling en zware straffen voor kleine overtredingen, militaire discipline en dwangarbeid. \"Ze maken slaven van ons, in plaats van ons te onderwijzen,\" zei een voormalige student.<br/><br/>Na één jaar Sawa worden de jongeren, grotendeels op basis van hun examenresultaten, ofwel gedwongen om in het leger te gaan, ofwel verder opgeleid en later ingelijfd om voor onbepaalde tijd voor de regering te werken in een civiele functie.<br/><br/>Sommige studenten verlaten de school om een militaire opleiding te ontlopen, maar leven in angst voor de beruchte razzia's van de regering. Veel meisjes kiezen voor een vroeg huwelijk en moederschap als een manier om het te ontlopen. Als vluchteling brengt dit aanzienlijke risico's met zich mee, zowel in Eritrea - gevangenschap en mishandeling als ze betrapt worden - als langs de migratieroutes.<br/><br/>Dit is een samenvatting van een rapport van Human Rights Watch <a href='https://www.hrw.org/report/2019/08/08/they-are-making-us-slaves-not-educating-us/how-indefinite-conscription-restricts' target='_blank'>‘They Are Making Us into Slaves, Not Educating Us’ : How Indefinite Conscription Restricts Young People’s Rights, Access to Education in Eritrea</a> gepubliceerd op 8 augustus, 2019",
    //       },
    //     },
    //   ],
    //   nextButtonStyle: {
    //     '&:hover': { color: colors.pink },
    //   },
    //   nextButtonText: 'Neem een beslissing >',
    //   nextStepId: 'choice camp militaire',
    // },
    {
      id: 'choice camp militaire',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Wat een dilemma. Wat zou jij doen in mijn plaats?<br/>Zou je <span class="background-underlined large">in Eritrea blijven</span>, ook al moet je over enkele jaren naar <span class="background-underlined large">het legerkamp gaan</span>? Of zou je <span class="background-underlined large">wegvluchten uit je land</span>?',
      choices: [
        // {
        //   type: 'button',
        //   key: 'button-1',
        //   text: 'Trouwen en een kind krijgen',
        //   buttonStyle: choiceButtonStyle,
        //   action: 'fakeChoice',
        //   actionText: 'De ouders van mijn beste vriend willen niet dat we trouwen omwille van mijn vader en onze problemen: ze zijn bang dat ze ook in de problemen gaan komen.',
        //   actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '30vw', maxWidth: '400px' },
        // },
        {
          type: 'button',
          key: 'button-2',
          text: 'In Eritrea blijven',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'epilogue_militaire',
        },
        {
          type: 'button',
          key: 'button-3',
          text: 'Eritrea verlaten',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 04',
        },
      ],
    },
    {
      id: 'epilogue_militaire',

      ...base_epilogue,

      // sound: SENAIT_FR_EPILOGUE_MILITAIRE,
      // sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Dit is hoe mijn leven in Eritrea eruitziet...',
          text: '',//'Ik heb mijn legeropleiding afgerond en ben nu al een paar jaar in dienst als soldaat. Er lijkt geen einde aan te komen. Ik zou liever verpleegster zijn of eender welk beroep waarvoor geen geweld nodig is en ik zou in mijn dorp willen wonen. Ik heb die vrijheid niet en ook geen enkele andere. Maar ik leef tenminste nog. Ik bid dat het geweld met Ethiopië niet meer zal oplaaien.<br/><br/>Ik mis mijn familie heel erg. We krijgen maar weinig verlof en als we elkaar dan een keer terugzien, zijn we altijd heel blij.',
          textStyle: { left: '45vw' },
        },
      ],
      // nextStepId: 'other_choices',
      nextStepId: "-1",
    },
    {
      id: 'map2',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map2,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 10',
    },
    {
      id: 'SENAIT 10',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ10,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Ik ben al 3 maanden in Shire, in de regio Tigray. ', delay: 5150 },
      //   { type: 'text', text: 'Het is een kleine stad vlak bij de grens, waar veel Eritree\u00ebrs wonen. ', delay: 4060 },
      //   { type: 'text', text: 'Maar de problemen tussen Eritrea en Ethiopi\u00eb zijn weer opgelaaid. ', delay: 5810 },
      //   { type: 'text', text: 'Er is in de hele regio veel geweld. ', delay: 5050 },
      //   { type: 'text', text: 'Mensen vluchten naar de vluchtelingenkampen in Soedan, ', delay: 3020 },
      //   { type: 'text', text: 'maar ze zeggen dat daar geen perspectief is. ', delay: 3010 },
      //   { type: 'text', text: 'Anderen gaan naar de hoofdstad Addis Abeba, ', delay: 3010 },
      //   { type: 'text', text: 'maar het is daar op dit ogenblik niet veilig voor Eritree\u00ebrs.', delay: 2990 },
      //   { type: 'text', text: '', delay: 5070 },
      //   { type: 'goToNext', delay: 1870 },
      // ],
      background: {
        src: greenSkirt,
        style: { transform: 'scale(1.2)', transition: 'transform linear' },
        animations: [
          { delay: 50, style: { animationDuration: '39040ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: 'transparent',
      // nextStepId: 'info after shire',
      nextStepId: 'SENAIT 11',
    },
    //25
    // {
    //   ...base_choice_style,
    //   id: 'info after shire',
    //   type: 'info',

    //   contentText:
    //     '<span class="background-underlined medium">Wat zou jij doen?</span><br/>Zou je naar <span class="background-underlined large">Soedan vluchten</span> of <span class="background-underlined very-large">naar de hoofdstad gaan</span>?',
    //   actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
    //   actions: [
    //     {
    //       type: 'button',
    //       key: 'button-read',
    //       text: 'Ik bekijk een reportage over Eritreërs die Tigray ontvluchtten',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonLire,
    //       iconHover: boutonLireHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         backgroundImage: backgroundPink,
    //         type: 'text',
    //         title:
    //           "<span class='subtitle'><a href='https://fr.africanews.com/2020/12/12/soudan-le-nouvel-exil-des-refugies-erythreens-en-ethiopie/' target='_blank'>Het videoverslag bekijken in plaats van het artikel? (in het Engels)</a></span>",
    //         text: 'Onder de duizenden mensen die de grens met Soedan overstaken om aan de gevechten in de regio Tigray te ontkomen, kenden sommigen al het leven als vluchteling. Zij waren Eritrea ontvlucht om te ontsnappen aan de repressie en de verplichte dienstplicht en hadden een toevluchtsoord gevonden in Tigray.<br/><br/>Na jaren van officiële oorlog ondertekenden Ethiopië en Eritrea in 2018 een vredesakkoord toen de premier van Ethiopië het \'Tigray People\'s Liberation Front\', de gezworen vijand van de Eritrese president, de macht uit handen nam. Na deze verbazingwekkende verandering van bondgenootschap lanceerde de Ethiopische Eerste Minister een offensief in de afgescheiden regio Tigray. Eritreeërs die lange tijd bescherming hadden genoten in Ethiopië, werden plots een doelwit.<br/><br/>Er zijn berichten over aanvallen op vluchtelingenkampen: "Soldaten kwamen ons kamp binnen en begonnen op iedereen te schieten - mannen, vrouwen en kinderen," zegt een Eritrese vluchteling die in de chaos zijn vrouw en kinderen uit het oog verloor. "Sommigen van de soldaten waren Eritreeërs, anderen Ethiopiërs," voegt hij eraan toe. Nu de relatie tussen Ethiopië en Eritrea is hersteld, zal Eritrea volgens een analist niet langer willen dat Ethiopië dissidenten of deserteurs uit het leger opneemt.<br/><br/>De vluchtelingenorganisatie van de Verenigde Naties (UNHCR) maakt zich grote zorgen over het lot van de Eritrese vluchtelingen die zich nog steeds in Ethiopië bevinden. Zij hebben een aanzienlijk aantal meldingen ontvangen van mensen die in de kampen zijn gedood of ontvoerd en onder dwang naar Eritrea zijn teruggezonden.<br/><br/>Dit fictieve artikel is gebaseerd op de reportage van Africanews <a href="https://fr.africanews.com/2020/12/12/soudan-le-nouvel-exil-des-refugies-erythreens-en-ethiopie/" target="_blank">« New exile for Eritrean refugees fleeing Ehtiopia »</a>, gepubliceerd op 12 december 2020.',
    //       },
    //     },
    //   ],
    //   nextButtonStyle: {
    //     '&:hover': { color: colors.pink },
    //   },
    //   nextButtonText: 'Neem een beslissing >',
    //   nextStepId: 'choice after shire',
    // },
    // {
    //   id: 'choice after shire',
    //   type: 'choice',

    //   ...base_choice_style,
    //   contentText:
    //     '<span class="background-underlined medium">Wat zou jij doen?</span><br/>Zou je naar <span class="background-underlined large">Soedan vluchten</span> of <span class="background-underlined very-large">naar de hoofdstad gaan</span>?',
    //   choices: [
    //     {
    //       type: 'button',
    //       key: 'button-1',
    //       text: 'Het geluk zoeken in de hoofdstad',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'fakeChoice',
    //       actionText:
    //         'De laatste weken zijn er heel veel Eritreeërs aangekomen in Addis Abeba. Het is heel moeilijk om een slaapplek en werk te vinden. En dan zijn er ook nog razzia’s en je kunt gearresteerd worden en teruggestuurd naar Eritrea. Ik ga toch liever naar de kampen in Soedan. Dan ben ik tenminste veilig en overleef ik tot het weer rustig is in Tigray.',
    //       actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-2',
    //       text: 'Naar een vluchtelingenkamp in Soedan gaan',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'SENAIT 11',
    //     },
    //   ],
    // },
    {
      id: 'SENAIT 11',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ11,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Ik zit al 2 maanden in een vluchtelingenkamp. ', delay: 2040 },
      //   { type: 'text', text: 'Het geweld in Tigray houdt aan. ', delay: 3130 },
      //   { type: 'text', text: 'We beseffen dat we voorlopig niet meer terug kunnen. ', delay: 2950 },
      //   { type: 'text', text: 'Maar welke toekomst heb ik hier? ', delay: 3890 },
      //   { type: 'text', text: 'Er is bijna geen onderwijs, geen werk en mijn familie is ver weg. ', delay: 2090 },
      //   { type: 'text', text: 'Ik voel me hier ook niet veilig. ', delay: 5070 },
      //   { type: 'text', text: 'Er zijn ontvoeringen, zeggen ze. Veel jongeren willen naar Libi\u00eb.', delay: 1880 },
      //   { type: 'text', text: '', delay: 4970 },
      //   { type: 'goToNext', delay: 1160 },
      // ],
      background: {
        src: campSoudan,
        // style: { transform: 'scale(1.2)', transition: 'transform linear' },
        // // animations: [
        // //   { delay: 50, style: { transitionDuration: '32120ms', transform: 'scale(1)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // // ],
      },
      textBackgroundColor: 'transparent',
      // nextStepId: 'mapIncoherence1',
      nextStepId: 'choice after 12',
    },
    // {
    //   id: 'SENAIT 12',
    //   type: 'sequence',
    //   // sound: SENAIT_FR_SEQ12,
    //   // sound_delay: 50,
    //   // sequence: [
    //   //   { type: 'text', text: 'De smokkelaars laten ons wachten bij een gebouw in de buurt van Karthoem', delay: 1180 },
    //   //   { type: 'text', text: 'Een eerste vrachtwagen is vertrokken, ', delay: 4820 },
    //   //   { type: 'text', text: 'mijn vrienden uit het kamp zijn erin geklommen, maar voor mij was er geen plaats meer.', delay: 2130 },
    //   //   { type: 'text', text: 'Ik wacht nu al een maand op mijn beurt ', delay: 4940 },
    //   //   { type: 'text', text: 'ik ben heel gefrustreerd dat ik niet aan boord kon. ', delay: 2120 },
    //   //   { type: 'text', text: 'Maar deze ochtend kreeg ik vreselijk nieuws: ', delay: 3020 },
    //   //   { type: 'text', text: 'de mensen uit de eerste vrachtwagen zijn door de maffia ontvoerd, in de woestijn ...', delay: 2990 },
    //   //   { type: 'text', text: 'Ik weet wat dat betekent, ontvoerd worden. ', delay: 5830 },
    //   //   { type: 'text', text: 'Iedereen weet het hier.', delay: 3020 },
    //   //   { type: 'text', text: 'En de rillingen lopen over mijn rug. ', delay: 2000 },
    //   //   { type: 'text', text: 'Maar ik weet ook dat als ik het nu toch niet wil doen, ik het geld dat ik al heb betaald, kwijt ben. ', delay: 2980 },
    //   //   { type: 'text', text: '', delay: 6020 },
    //   //   { type: 'goToNext', delay: 1150 },
    //   // ],
    //   background: {
    //     src: batimentRoute,
    //     // style: { transform: 'scale(1.2)', transition: 'transform linear' },
    //     // // animations: [
    //     // //   { delay: 50, style: { transitionDuration: '32120ms', transform: 'scale(1)' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
    //     // // ],
    //   },
    //   textBackgroundColor: '#1A1A18',
    //   nextStepId: 'info after 12',
    // },
    // {
    //   ...base_choice_style,
    //   id: 'info after 12',
    //   type: 'info',

    //   contentText:
    //     'Ik weet echt niet wat ik moet doen. Wat zou jij in mijn plaats doen?<br/>Zou je de <span class="background-underlined large">eerstvolgende vrachtwagen</span> nemen, ondanks het risico, of zou je terugkeren <span class="background-underlined large">naar het kamp</span>?',
    //   actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
    //   actions: [
    //     {
    //       type: 'button',
    //       key: 'button-watch-2',
    //       text: 'Ik luister naar de getuigenis van een Eritrese jongere die in Libië is geweest',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonRegarder,
    //       iconHover: boutonRegarderHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         type: 'video',
    //         videoIframe: getYoutubeIframe('t61GTNcbjzA'),
    //       },
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-read',
    //       text: 'Ik lees een artikel over het lot van Eritreeërs op de migratieroutes',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonLire,
    //       iconHover: boutonLireHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         backgroundImage: backgroundPink,
    //         type: 'text',
    //         title: "De gevaarlijke tocht naar een nieuwe thuis<br/><span class='subtitle'>MO<sup>*</sup> magazine (samenvatting van het oorspronkelijk artikel)</span>",
    //         text: 'Kidnappings voor losgeld, Libische slavenmarkten, een levensgevaarlijke tocht over de Middellandse Zee... Hoe komt het dat Eritrese vluchtelingen steeds opduiken in de meest onmenselijke vluchtverhalen?<span class="inline-title">« Noord-Korea van Afrika »</span>Eritrese vluchtelingen hebben duidelijk recht op asiel en zijn zelfs de groep met de hoogste erkenningsgraad in de EU. Het land kreeg niet voor niets de bijnaam ‘het Noord-Korea van Afrika’. Sinds zijn onafhankelijkheid 25 jaar geleden, groeide het land dan ook uit tot het minst vrije land van Sub-Saharaans Afrika: Het enige lot van een journalist is er de gevangenis, politieke partijen en middenveldorganisaties zijn verboden en onafhankelijke justitie bestaat niet. <br/><br/>De andere gelijkenis met Noord-Korea is de oneindige militaire dienstplicht, die vaak in dwangarbeid wordt verdergezet. Naast de afwezigheid van politieke vrijheid ontneemt de oneindig durende legerdienst je ook nog de persoonlijke vrijheid om een eigen leven uit te bouwen. <span class="inline-title">Mensensmokkel</span>Er bestaat weinig twijfel dat Eritreeërs goede redenen hebben om het land te ontvluchten, maar dat betekent niet dat ze makkelijk een nieuwe thuis vinden. Nog meer dan andere vluchtelingen, lijken zij erg kwetsbaar voor misbruik van mensensmokkelaars die hen kennelijk in het vizier hebben. Die mensensmokkel begint al in eigen land: Omdat Eritrea verlaten strafbaar is, moet wie toch wil vertrekken geld aan binnenlandse smokkelaars betalen. <br/><br/>Zoals vaak, geraakt een groot deel niet verder dan de buurlanden. Naar schatting bevinden 250.000 Eritreeërs zich in vluchtelingenkampen in Soedan en Ethiopië. Sommigen kjjken uit naar een meer duurzame oplossing: Een leven in deze wachtkamers biedt weinig toekomstperspectief. Bovendien voelen velen zich niet veilig in de kampen. Naar verluidt vinden er ontvoeringen plaats, waarbij veiligheidsagenten en gewapende bendes betrokken zijn die losgeld eisen van families.<br/><br/>Tot 2013 liep de meest populaire route via Egypte richting Israël. Maar velen kwamen in handen van -alweer- kidnappers terecht in de Sinaïwoestijn. Hun familieleden kregen gruwelijke telefoontjes waarin ze te horen kregen hoe hun naasten gemarteld en verkracht werden. Kregen ze de vereiste som geld niet bijeen, dan werd het slachtoffer vermoord.<br/><br/>Sindsdien is de Libische route in populariteit toegenomen. Dit ondanks de burgeroorlog, want Libische milities ondervonden snel dat de smokkel van Eritrese vluchtelingen een interessante bron van inkomsten is. De weg door Libië is dus niet goedkoop en erg gevaarlijk. Opnieuw waren het vooral Eritreeërs die in beeld kwamen toen de wereld de Libische slavenmarkten leerde kennen.<br/><br/>Dit artikel is een samenvatting van extracten van het artikel van MO* Magazine <a href="https://www.mo.be/analyse/waarom-eritree-rs-zo-vaak-opduiken-vluchtelingenverhalen" target="_blank">« Waarom Eritreeërs steeds opduiken in onmenselijke vluchtverhalen »</a> gepubliceerd op 11 september 2018.',
    //       },
    //     },
    //   ],
    //   nextButtonStyle: {
    //     '&:hover': { color: colors.pink },
    //   },
    //   nextButtonText: 'Neem een beslissing >',
    //   nextStepId: 'choice after 12',
    // },
    //30
    {
      id: 'choice after 12',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Ik weet echt niet wat ik moet doen. Wat zou jij in mijn plaats doen?<br/>Ga jij mee <span class="background-underlined large">met de andere jongeren</span>, ondanks de gevaren, of <span class="background-underlined large">blijf je in het kamp</span>?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'In het kamp blijven',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Weet je <span class="background-underlined medium">dat zeker</span>?<br/>Ik zie hier <span class="background-underlined very-large">weinig toekomst voor mezelf</span>.',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue tente',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Vertrekken met de andere jongeren',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: 'Weet je <span class="background-underlined medium">dat zeker</span>?<br/>Er kunnen heel wat vreselijke dingen gebeuren onderweg.',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'SENAIT 08',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'epilogue tente',

      ...base_epilogue,

      // sound: SENAIT_FR_EPILOGUE_3,
      // sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Dit is hoe mijn leven eruitziet in vluchtelingenkampen...',
          // text: 'Het geweld in Tigray is gestopt en ik ben teruggekeerd naar Ethiopië, naar een ander vluchtelingenkamp. Jammer genoeg lijken alle kampen op elkaar: er is geen toekomst, gewoon het dagelijkse leven dat zich eindeloos herhaalt. Alsof het leven op pauze staat. En ik wil zoveel doen, het is zo moeilijk om hier te leven. Maar ik ben tenminste veilig en ik leef nog. Daar ben ik heel bij om. Ik hoop dat ik op een dag weer bij mijn familie kan zijn.',
          textStyle: { left: '45vw' },
        },
      ],
      // nextStepId: 'other_choices',
      nextStepId: "-1",
    },
    {
      id: 'map lybie from soudan',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map3,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      // nextStepId: 'SENAIT 13',
      nextStepId: 'SENAIT 14',
    },
    {
      id: 'SENAIT 14',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ14,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Mijn oom heeft het geld betaald en ik ben eindelijk vrij. ', delay: 1140 },
      //   { type: 'text', text: 'Maar ik kan weer gearresteerd of ontvoerd worden zolang ik in Libi\u00eb ben. ', delay: 3940 },
      //   { type: 'text', text: 'Dit land is een hel voor mensen als ik. ', delay: 4070 },
      //   { type: 'text', text: 'Ik moet hier weg. ', delay: 2930 },
      //   { type: 'text', text: 'Maar waar naartoe? ', delay: 1100 },
      //   { type: 'text', text: 'Of ik ga terug naar het kamp in Soedan. Of ik ga naar Europa. ', delay: 1900 },
      //   { type: 'text', text: 'Ik wil geen rubberbootje nemen, ik heb gehoord dat er veel zinken. ', delay: 4030 },
      //   { type: 'text', text: 'Maar de houten boten kosten een pak geld en ik heb geen geld meer. ', delay: 4910 },
      //   { type: 'text', text: 'De smokkelaars doen me een voorstel: ', delay: 5090 },
      //   { type: 'text', text: 'een paar maanden voor hen werken in ruil voor een plaatsje op een houten boot. ', delay: 2140 },
      //   { type: 'text', text: '', delay: 5870 },
      //   { type: 'goToNext', delay: 1900 },
      // ],
      background: {
        src: beach,
        style: { animationFillMode: 'forwards', animationTimingFunction: 'linear' },
        animations: [{ delay: 50, style: { animationName: 'scale20', animationDuration: '39020ms' } }],
      },
      backgroundEffect: {
        style: { opacity: 1, backgroundColor: 'black', transition: 'opacity linear' },
        animations: [
          { delay: 50, style: { animationName: 'opacityFullToNone', animationDuration: '1950ms' } },
          { delay: 35000, style: { animationName: 'opacityNoneToFull', animationDuration: '2000ms' } },
        ],
      },
      textBackgroundColor: 'transparent',
      // nextStepId: 'info bateau pneumatique',
      nextStepId: 'SENAIT 15',
    },
    // {
    //   ...base_choice_style,
    //   id: 'info bateau pneumatique',
    //   type: 'info',

    //   contentText:
    //     'Wat een moeilijke keuze. Wat zou jij doen?<br/>Zou je <span class="background-underlined medium">terugkeren</span> of zou je met een rubberbootje <span class="background-underlined medium">naar Europa</span> gaan? Of zou je het voor<span class="background-underlined large">stel van de smokkelaars aanvaa</span>rden in ruil voor een overtocht op een houten boot?',
    //   actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',

    //   actions: [
    //     {
    //       type: 'button',
    //       key: 'button-read',
    //       text: 'Ik lees een rapport over de situatie van migranten in Libië',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonLire,
    //       iconHover: boutonLireHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         backgroundImage: backgroundPink,
    //         type: 'text',
    //         title: "‘Tussen leven en dood’: vluchtelingen en migranten gevangen in spiraal van geweld in Libië<br/><span class='subtitle'>Amnesty International rapport (samenvatting)</span>",
    //         text: "Vluchtelingen en migranten in Libië zitten gevangen in een spiraal van ernstige mensenrechtenschendingen en misbruik, waaronder langdurige willekeurige opsluiting, foltering en andere vormen van mishandeling, onwettige moorden, verkrachting, dwangarbeid en uitbuiting door overheids- en niet-overheidsactoren in een klimaat van bijna volledige straffeloosheid.<br/><br/>De benarde situatie van vluchtelingen en migranten in Libië speelt zich af tegen de achtergrond van een aanhoudend gewapend conflict, onveiligheid en wetteloosheid. Desondanks blijft de Europese Unie (EU), in een poging om het aantal vluchtelingen in Europa te verminderen, een beleid voeren dat duizenden vluchtelingen en migranten in Libië gevangenhoudt. Dit doen ze door bijvoorbeeld hulp te geven aan de Libische kustwacht die vluchtelingen en migranten op zee onderschept en hen in Libië houdt. Dit leidt tot willekeurige detentie en verdwijning van duizenden mensen.<br/><br/>Vluchtelingen en migranten in Libië lopen voortdurend het risico te worden gearresteerd of ontvoerd door veiligheidstroepen, leden van milities en gewapende groepen, smokkelaars en andere criminelen. De mensen die voor dit rapport werden geïnterviewd zijn allen - zonder proces en zonder mogelijkheid om hun gevangenschap aan te vechten- ten minste één keer gearresteerd of ontvoerd. Allen werden ook minstens één keer vastgehouden voor losgeld, gemarteld, verkracht of uitgehongerd tot hun families de gevraagde som geld bijeenkregen. Een aantal van hen verklaarde getuige te zijn geweest van verschillende sterfgevallen in gevangenschap van vrienden, familieleden of andere gedetineerden.<br/><br/>Zelfs wanneer ze niet in gevangenschap zitten, zijn vluchtelingen en migranten kwetsbaar voor misbruik en uitbuiting door gewapende groepen en milities, of door gewetenloze werkgevers, waartegen zij geen bescherming hebben.<br/><br/>Duizenden vrouwen, mannen en kinderen die daar in erbarmelijke omstandigheden vastzitten, hebben weinig andere keuze dan de gevaarlijke oversteek van de Middellandse Zee te wagen. Een tocht die nog steeds vol risico's is. Velen van hen worden onderschept door de Libische kustwacht en teruggestuurd naar Libië om daar opnieuw te worden geconfronteerd met dezelfde cyclus van misbruik en geweld.<br/><br/>Om deze cyclus te doorbreken, moeten de Libische autoriteiten een einde maken aan het willekeurig en voor onbepaalde tijd vasthouden van vluchtelingen en migranten, en moet de EU haar samenwerking met Libië op het gebied van migratie volledig herzien.<br/><br/>Dit is een samenvatting van het verslag van Amnesty International <a href='https://www.amnesty.org/fr/documents/mde19/3084/2020/fr/' target='_blank'>« ’Between life and death’: Refugees and migrants trapped in Libya’s cycle of abuse »</a> van 2020.",
    //       },
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-watch-1',
    //       text: 'Ik luister naar een jonge Eritrese vrouw die haar oversteek per boot vertelt',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonRegarder,
    //       iconHover: boutonRegarderHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         type: 'video',
    //         videoIframe: getYoutubeIframe('MWdzO_CjPAk'),
    //       },
    //     },
    //   ],
    //   nextButtonStyle: {
    //     '&:hover': { color: colors.pink },
    //   },
    //   nextButtonText: 'Neem een beslissing >',
    //   nextStepId: 'choice bateau pneumatique',
    // },
    //35
    // {
    //   id: 'choice bateau pneumatique',
    //   type: 'choice',

    //   ...base_choice_style,
    //   contentText:
    //     'Wat een moeilijke keuze. Wat zou jij doen?<br/>Zou je <span class="background-underlined medium">terugkeren</span> of zou je met een rubberbootje <span class="background-underlined medium">naar Europa</span> gaan? Of zou je het voor<span class="background-underlined large">stel van de smokkelaars aanvaa</span>rden in ruil voor een overtocht op een houten boot?',
    //   choices: [
    //     {
    //       type: 'button',
    //       key: 'button-1',
    //       text: 'Terugkeren naar Soedan',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'map soudan from lybie',
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-2',
    //       text: 'Het voorstel van de smokkelaars aanvaarden',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'fakeChoice',
    //       actionText:
    //         'De politie heeft me gearresteerd toen ik aan het werk was en ik zit nu in een Libische gevangenis. Maar de gevangenisbewaarders zijn benaderd door smokkelaars, die ons wilden ‘kopen’. We zijn weer meegenomen naar dezelfde plek in de woestijn. Ik moet weer betalen. Ik moet weg uit deze hel, zo snel mogelijk! Ik neem een rubberbootje, kan me niet schelen dat ik het niet overleef, als ik hier maar wegkom.',
    //       actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceMedium})`, maxHeight: '60vh', width: '40vw', maxWidth: '500px' },
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-3',
    //       text: 'Zo snel mogelijk oversteken met een rubberbootje',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'SENAIT 15',
    //     },
    //   ],
    // },
    // {
    //   id: 'map soudan from lybie',
    //   type: 'map',
    //   background: baseBackgroundImg,
    //   mapImage: map4,
    //   mapContainerClass: 'cursor-gray',
    //   nextStepDelay: 3500,
    //   nextStepId: 'mapIncoherence2',
    // },
    {
      id: 'SENAIT 15',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ15,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'De overtocht was een nachtmerrie. ', delay: 1180 },
      //   { type: 'text', text: 'De smokkelaars hebben ons in het geheim op de boot gezet, \u2019s nachts.', delay: 2860 },
      //   { type: 'text', text: 'We waren met 23, te veel voor zo\u2019n klein rubberbootje. ', delay: 4000 },
      //   { type: 'text', text: 'We hebben gebeden dat de kustwacht ons niet zou zien, ', delay: 4090 },
      //   { type: 'text', text: 'dat er geen storm zou opsteken, want ik kan niet zwemmen.', delay: 3050 },
      //   { type: 'text', text: 'Op een bepaald moment was de benzine op. ', delay: 3030 },
      //   { type: 'text', text: 'We zaten midden op zee en we konden niets doen, NIETS!', delay: 2850 },
      //   { type: 'text', text: 'Alleen maar wachten \u2026 ', delay: 5050 },
      //   { type: 'text', text: 'en hopen dat er een boot zou langsvaren. ', delay: 1120 },
      //   { type: 'text', text: 'Dit waren de 2 langste dagen van mijn leven! ', delay: 2850 },
      //   { type: 'text', text: 'En dan \u2026 heeft een boot ons gered.', delay: 3920 },
      //   { type: 'text', text: '', delay: 4030 },
      //   { type: 'goToNext', delay: 990 },
      // ],
      background: {
        src: baseBackgroundImg, // medecinBateau,
      },
      foreground: {
        src: bateau_pneumatique,
        style: { width: '100vw', animationFillMode: 'forwards', animationTimingFunction: 'linear', opacity: 0 },
        animations: [{ delay: 50, style: { animationName: 'animationSenaitBateau', animationDuration: '39020ms', opacity: 1 } }],
      },
      textBackgroundColor: '#222726',
      nextStepId: 'map to italy',
    },
    {
      id: 'map to italy',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map5,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'SENAIT 16',
    },
    {
      id: 'SENAIT 16',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ16,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'En nu ben ik in Europa \u2026 ', delay: 1110 },
      //   { type: 'text', text: 'Ik ben op een klein Italiaans eiland, Lampedusa. ', delay: 1960 },
      //   { type: 'text', text: 'Ik heb mijn oom gebeld om hem om advies te vragen. ', delay: 3980 },
      //   { type: 'text', text: 'Hij heeft gezegd dat ik naar hem in Engeland moet komen, ', delay: 3050 },
      //   { type: 'text', text: 'waar ik bij hem kan werken en mijn schuld kan terugbetalen. ', delay: 2940 },
      //   { type: 'text', text: '', delay: 4000 },
      //   { type: 'goToNext', delay: 200 },
      // ],
      background: {
        src: refugee,
        style: {},
        animations: [
          { delay: 3000, style: { animationDuration: '17240ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      backgroundEffect: {
        style: { opacity: 1, backgroundColor: 'black' },
        animations: [{ delay: 50, style: { animationDuration: '3950ms', animationName: 'opacityFullToNone' } }],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'map to belgium',
    },
    //40
    {
      id: 'map to belgium',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: map6,
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      // nextStepId: 'SENAIT 17',
      nextStepId: 'SENAIT 18',
    },
    // {
    //   id: 'SENAIT 17',
    //   type: 'sequence',
    //   // sound: SENAIT_FR_SEQ17,
    //   // sound_delay: 50,
    //   // sequence: [
    //   //   { type: 'text', text: 'Dus ben ik uit Itali\u00eb weggegaan, door Frankrijk', delay: 1070 },
    //   //   { type: 'text', text: 'Ik zit nu in Belgi\u00eb en ik moet opnieuw een zee oversteken. ', delay: 3080 },
    //   //   { type: 'text', text: 'Naar het schijnt kan dat als je je in een vrachtwagen verstopt \u2026 ', delay: 3920 },
    //   //   { type: 'text', text: 'Dat stelt me een beetje gerust.', delay: 3090 },
    //   //   { type: 'text', text: 'Intussen overnacht ik bij mensen of verenigingen ', delay: 2030 },
    //   //   { type: 'text', text: 'en soms in een park. ', delay: 2940 },
    //   //   { type: 'text', text: 'Ik heb honger en heb het koud. ', delay: 2050 },
    //   //   { type: 'text', text: '', delay: 3020 },
    //   //   { type: 'goToNext', delay: 1840 },
    //   // ],
    //   background: {
    //     src: phoneBooth,
    //     style: {},
    //     animations: [
    //       { delay: 50, style: { animationDuration: '23040ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
    //     ],
    //   },
    //   // textBackgroundColor: '#47423F',
    //   nextStepId: 'SENAIT 18',
    // },
    {
      id: 'SENAIT 18',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ18,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Ik heb het geprobeerd met die stomme vrachtwagens. Telkens opnieuw. ', delay: 2210 },
      //   { type: 'text', text: 'Soms denk ik dat ik de kracht niet meer heb om het nog een keer te doen. ', delay: 4990 },
      //   { type: 'text', text: 'En wat als ik hier asiel aanvraag?', delay: 3990 },
      //   { type: 'text', text: 'Eigenlijk wil ik maar gewoon in veiligheid zijn \u2026 ', delay: 2910 },
      //   { type: 'text', text: 'Maar in Engeland, bij mijn oom, ben ik weer bij familie. ', delay: 3090 },
      //   { type: 'text', text: '', delay: 3980 },
      //   { type: 'goToNext', delay: 1050 },
      // ],
      background: {
        src: parcMaximilien,
        style: { width: '120vw', position: 'relative', left: '-20vw', transition: 'transform linear' },
        animations: [
          { delay: 50, style: { animationDuration: '22220ms', animationName: 'translateX0To20vw' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: 'transparent',
      // nextStepId: 'info in belgium',
      nextStepId: 'SENAIT 19',
    },
    // {
    //   ...base_choice_style,
    //   id: 'info in belgium',
    //   type: 'info',

    //   contentText:
    //     'Wat zou jij doen in mijn plaats?<br/>Zou jij nog proberen over te steken <span class="background-underlined large">naar Engeland</span> of zou je een <span class="background-underlined very-large">asielaanvraag indienen in Belg</span>ië?',
    //   actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
    //   actions: [
    //     {
    //       type: 'button',
    //       key: 'button-read',
    //       text: 'Ik lees dit artikel over de overtocht naar Engeland',
    //       buttonStyle: { '&:hover': { color: colors.pink } },
    //       icon: boutonLire,
    //       iconHover: boutonLireHoover,
    //       action: 'openDialog',
    //       dialogContent: {
    //         transition: 'slideUp',
    //         backgroundImage: backgroundPink,
    //         type: 'text',
    //         title: 'In de voetsporen van migranten die naar Engeland willen',
    //         text: 'Aan de rand van het Brusselse Noordstation blijft de kleine groep Eritreeërs onopgemerkt voor de vele voorbijgangers. Schimmen die verdwijnen in het straatbeeld. Ze zijn jong en discreet. De ervaring van hun land te moeten ontvluchten, heeft hen geleerd om op hun hoede te zijn.<br/><br/>Met de trein gaan ze naar een parkeerplaats langs een snelweg. ‘s Nachts wachten ze op het juiste moment om in een vrachtwagen te stappen, op weg naar Bergen en Calais. Anderen richten zich dan weer tot mensensmokkelaars. Een buurtbewoner, die hun vertrouwen heeft gewonnen, vertelt over de angst die hij bij deze jonge Eritreeërs voelt, vooral ten opzichte van de smokkelaars.<br/><br/>Ondanks talloze mislukte pogingen zijn de zogenaamde "transmigranten" bereid alles te doen om Engeland te bereiken. Zij hebben hun zinnen gezet op Engeland omdat zij daar vaak familie hebben en er Engels wordt gesproken.<br/><br/>Velen van hen verblijven in het Maximiliaan park bij het Brusselse Noordstation. Of het nu gaat om Eritreërs, Ethiopiërs of Soedanezen, velen van hen zijn op de vlucht voor een conflict of voor gedwongen rekrutering bij een gewapende groepering. Meer dan een kwart van hen zijn minderjarig.<br/><br/>Velen hebben recht op asiel in België. Hun doel om Engeland te bereiken is vaak het resultaat van verkeerde informatie: zij denken dat zij niet anders kunnen dan het kanaal naar Engeland over te steken omdat zij anders zouden teruggestuurd worden naar Italië of Griekenland, in toepassing van de "Dublin-verordening", die bepaalt dat een migrant asiel moet aanvragen in het eerste EU-land waar hij of zij voet aan wal zet. Vele organisaties zetten zich in om deze vluchtelingen te informeren over hun rechten in België. Van zodra ze weten dat ze waarschijnlijk hier zullen worden toegelaten, geven velen aan in België te willen blijven en dienen ze hier een verzoek tot internationale bescherming in.<br/><br/>Dit fictief artikel is geïnspireerd op het onderzoek <a href=\'https://dossiers.parismatch.be/migrants/migrants.php\' target=\'_blank\'>« Migrants&thinsp;: l’autoroute du trafic / Dans les pas des migrants »</a> gepubliceerd door Paris Match en 2018.',
    //       },
    //     },
    //   ],
    //   nextButtonStyle: {
    //     '&:hover': { color: colors.pink },
    //   },
    //   nextButtonText: 'Neem een beslissing >',
    //   nextStepId: 'choice in belgium',
    // },
    // {
    //   id: 'choice in belgium',
    //   type: 'choice',

    //   ...base_choice_style,
    //   contentText:
    //     'Wat zou jij doen in mijn plaats?<br/>Zou jij nog proberen over te steken <span class="background-underlined large">naar Engeland</span> of zou je een <span class="background-underlined very-large">asielaanvraag indienen in Belg</span>ië?',
    //   choices: [
    //     {
    //       type: 'button',
    //       key: 'button-1',
    //       text: 'Blijven proberen om naar Engeland te gaan',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'fakeChoice',
    //       actionText: 'Mijn pogingen lopen elke keer op niets uit. Ik zie geen uitweg! Ik geef het nu maar op en blijf in België.',
    //       actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '30vw', maxWidth: '400px' },
    //     },
    //     {
    //       type: 'button',
    //       key: 'button-2',
    //       text: 'Een asielaanvraag indienen in België',
    //       buttonStyle: choiceButtonStyle,
    //       action: 'goNext',
    //       nextStepId: 'SENAIT 19',
    //     },
    //   ],
    // },
    //45
    {
      id: 'SENAIT 19',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ19,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Ik heb een asielaanvraag ingediend. ', delay: 3130 },
      //   { type: 'text', text: 'Na 9 lange maanden heb ik het vluchtelingenstatuut gekregen. ', delay: 2880 },
      //   { type: 'text', text: 'Ik kan het niet geloven, nooit gedacht dat het geluk me nog zou toelachen.', delay: 4110 },
      //   { type: 'text', text: 'Ik ben eindelijk veilig \u2026 en vrij. ', delay: 4980 },
      //   { type: 'text', text: 'Er wachten me nog heel wat beproevingen. Om te beginnen moet ik een woning vinden.', delay: 4000 },
      //   { type: 'text', text: 'Maar hoewel de problemen gelukkig minder zwaar zijn dan wat ik al heb meegemaakt, ', delay: 4940 },
      //   { type: 'text', text: 'lijken ze me toch onoverkomelijk', delay: 4090 },
      //   { type: 'text', text: 'Mijn sociaal assistent zegt me dat ik eindelijk \u2018een leven kan opbouwen\u2019,', delay: 2950 },
      //   { type: 'text', text: 'maar eerst moet ik \u2018mezelf weer opbouwen\u2019. ', delay: 5010 },
      //   { type: 'text', text: 'Het lijkt alsof alles wat ik meegemaakt heb,', delay: 3950 },
      //   { type: 'text', text: 'mij vanbinnen kapot heeft gemaakt, ook al zie je dat niet aan de buitenkant. ', delay: 2180 },
      //   { type: 'text', text: 'Ik heb nachtmerries over wat me in Libi\u00eb is overkomen.', delay: 5800 },
      //   { type: 'text', text: 'Ik moet herstellen en dat vraagt tijd.', delay: 3160 },
      //   { type: 'text', text: '', delay: 3860 },
      //   { type: 'goToNext', delay: 190 },
      // ],
      background: {
        src: porteEtLit,
        style: { transform: 'scale(1.2)' },
        animations: [
          { delay: 50, style: { animationDuration: '55230ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: 'transparent',
      // nextStepId: 'SENAIT 20',
      nextStepId: 'info se battre',
    },
    // {
    //   id: 'SENAIT 20',
    //   type: 'sequence',
    //   // sound: SENAIT_FR_SEQ20,
    //   // sound_delay: 50,
    //   // sequence: [
    //   //   { type: 'text', text: 'Maar ik heb geen tijd. ', delay: 6240 },
    //   //   { type: 'text', text: 'Ik moet overdag naar school, Nederlands  leren', delay: 1900 },
    //   //   { type: 'text', text: 'een huis zoeken in het weekend en naar al mijn afspraken gaan.', delay: 2890 },
    //   //   { type: 'text', text: 'Ik ben mijn eigen ouder sinds mijn 13de, maar ik ben nog een kind.', delay: 3100 },
    //   //   { type: 'text', text: 'Ik heb hulp nodig \u2026 ', delay: 4070 },
    //   //   { type: 'text', text: 'Die krijg ik soms, maar niet altijd. ', delay: 1990 },
    //   //   { type: 'text', text: 'Geen enkele huiseigenaar wil me een studio verhuren.', delay: 3050 },
    //   //   { type: 'text', text: 'Net zo met studentenjobs en ik moet toch mijn oom terugbetalen. ', delay: 3850 },
    //   //   { type: 'text', text: 'Ik maak ook moeilijk vrienden', delay: 4970 },
    //   //   { type: 'text', text: 'Ik wil gewoon een kans krijgen, hoe kan ik anders aan een toekomst werken?', delay: 2100 },
    //   //   { type: 'text', text: '', delay: 6010 },
    //   //   { type: 'goToNext', delay: 1060 },
    //   // ],
    //   background: {
    //     src: pousette,
    //     style: {},
    //     animations: [
    //       { delay: 50, style: { animationDuration: '41230ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
    //     ],
    //   },
    //   // textBackgroundColor: '#47423F',
    //   nextStepId: 'info se battre',
    // },
    {
      ...base_choice_style,
      id: 'info se battre',
      type: 'info',

      contentText: 'Ik vind het zo moeilijk en voel me alleen. <span class="background-underlined very-large">Wat moet ik doen</span>?',
      actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
      actions: [
        // {
        //   type: 'button',
        //   key: 'button-watch-1',
        //   text: 'Ik luister naar een expert over de traumatische ervaring van vluchtelingen',
        //   buttonStyle: { '&:hover': { color: colors.pink } },
        //   icon: boutonRegarder,
        //   iconHover: boutonRegarderHoover,
        //   action: 'openDialog',
        //   dialogContent: {
        //     transition: 'slideUp',
        //     type: 'video',
        //     videoIframe: getYoutubeIframe('aTuiJLhAino'),
        //   },
        // },
        {
          type: 'button',
          key: 'button-watch-2',
          text: 'Ik luister naar hoe Sham haar aankomst in België beleefde',
          buttonStyle: { '&:hover': { color: colors.pink } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: 'openDialog',
          dialogContent: {
            transition: 'slideUp',
            type: 'video',
            videoIframe: getYoutubeIframe('148o4MJwjqA'),
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.pink },
      },
      nextButtonText: 'Neem een beslissing >',
      nextStepId: 'choice se battre',
    },
    {
      id: 'choice se battre',
      type: 'choice',

      ...base_choice_style,
      contentText: 'Ik vind het zo moeilijk en voel me alleen. <span class="background-underlined very-large">Wat moet ik doen</span>?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'De moed niet verliezen: het komt goed!',
          buttonStyle: choiceButtonStyle,
          action: 'fakeChoice',
          actionText: 'Neen, ik kan niet meer …',
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: '60vh', width: '30vw', maxWidth: '400px' },
        },
        {
          type: 'button',
          key: 'button-2',
          text: ' Het komt niet goed: ik geef het op.',
          buttonStyle: choiceButtonStyle,
          action: 'goNext',
          nextStepId: 'SENAIT 21',
        },
      ],
    },
    {
      id: 'SENAIT 21',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ21,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Mijn sociaal assistent is langsgekomen. ', delay: 7110 },
      //   { type: 'text', text: 'Ze zegt dat ze me niet in de steek zal laten. ', delay: 2930 },
      //   { type: 'text', text: 'Dat zij er nog genoeg in gelooft voor ons twee\u00ebn, ook al geloof ik er zelf niet meer in. ', delay: 2130 },
      //   { type: 'text', text: 'Want ik ben de sterkste persoon die ze kent. ', delay: 5900 },
      //   { type: 'text', text: 'Het bewijs is er: alle beproevingen die ik al sinds mijn 14de heb doorgemaakt.', delay: 2990 },
      //   { type: 'text', text: 'Ik KAN er komen. ', delay: 5070 },
      //   { type: 'text', text: 'Samen beslissen we om een paar verenigingen te contacteren.', delay: 2870 },
      //   { type: 'text', text: '', delay: 3140 },
      //   { type: 'goToNext', delay: 1860 },
      // ],
      background: {
        src: handsBehindWindow,
        style: { transform: 'scale(1.2)' },
        animations: [
          { delay: 50, style: { animationDuration: '34000ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'SENAIT 22',
    },
    //50
    {
      id: 'SENAIT 22',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ22,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Dankzij een van die verenigingen heb ik een engel ontmoet: Lucie en haar gezin. ', delay: 2080 },
      //   { type: 'text', text: 'Dit was een keerpunt voor mij. ', delay: 6030 },
      //   { type: 'text', text: 'Ik voel dat mijn leven weer waarde heeft voor iemand en dus ook voor mijzelf. ', delay: 2110 },
      //   { type: 'text', text: 'Met de hulp van de vereniging en van Lucie ', delay: 5000 },
      //   { type: 'text', text: 'heb ik een studio \u00e9n werk gevonden en verbetert mijn Nederlands snel. ', delay: 2800 },
      //   { type: 'text', text: 'Eindelijk valt alles een beetje op zijn plaats en zie ik licht aan het einde van de tunnel.', delay: 6020 },
      //   { type: 'text', text: '', delay: 5990 },
      //   { type: 'goToNext', delay: 1190 },
      // ],
      background: {
        src: cuisineLegume,
        style: { transform: 'scale(1.2)' },
        animations: [
          { delay: 50, style: { animationDuration: '31220ms', animationName: 'scaleDown20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'SENAIT 23',
    },
    {
      id: 'SENAIT 23',
      type: 'sequence',
      sound: SENAIT_JUNIOR_FR_SEQ23,
      sound_delay: 50,
      // sequence: [
      //   { type: 'text', text: 'Ik heb recht op gezinshereniging met mijn moeder en broertjes, ', delay: 2180 },
      //   { type: 'text', text: 'zij mogen bij mij komen.', delay: 3960 },
      //   { type: 'text', text: 'Maar er is een probleem: mijn familie moet een aanvraag indienen bij de Belgische ambassade in Ethiopi\u00eb,', delay: 2980 },
      //   { type: 'text', text: 'want er is geen ambassade in Eritrea. ', delay: 6890 },
      //   { type: 'text', text: 'Maar als ze Eritrea verlaten, kunnen ze nooit meer terug als de gezinshereniging niet goedgekeurd zou worden.', delay: 2220 },
      //   { type: 'text', text: 'Ze moeten dus het risico nemen voor de rest van hun leven vast te zitten in Ethiopi\u00eb. ', delay: 7000 },
      //   { type: 'text', text: 'Wat een dilemma. ', delay: 5940 },
      //   { type: 'text', text: 'Ik wil graag gezinshereniging om hen hier in veiligheid te krijgen,', delay: 2040 },
      //   { type: 'text', text: 'niet om hen nog meer gevaar te laten lopen. ', delay: 3980 },
      //   { type: 'text', text: 'Maar ik mis hen en ik heb hen nodig, ', delay: 3040 },
      //   { type: 'text', text: 'want ik ben nog een kind, ook al heb ik verantwoordelijkheden als een volwassene', delay: 2900 },
      //   { type: 'text', text: 'En als ik het nu niet doe, dan kan het later niet meer, want je moet minderjarig zijn.', delay: 5110 },
      //   { type: 'text', text: '', delay: 5990 },
      //   { type: 'goToNext', delay: 1850 },
      // ],
      background: {
        src: paperWork,
        style: {},
        animations: [
          { delay: 50, style: { animationDuration: '56080ms', animationName: 'scale10' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: 'black' },
        animations: [{ delay: 44100, style: { animationDuration: '5000ms', animationName: 'opacityNoneToFull' } }],
      },
      textBackgroundColor: 'transparent',
      nextStepId: 'info final',
    },
    {
      ...base_choice_style,
      id: 'info final',
      type: 'info',

      contentText:
        'Nu sna<span class="background-underlined very-large">p je mijn dilemma</span>. Wat zou jij in mijn plaats doen?<br/>Start je, ondanks het gevaar, de pro<span class="background-underlined very-large">cedure waarmee mijn moeder en broert</span>jes mogelijks naar België kunnen komen? Of <span class="background-underlined large">neem je dit risico niet</span>?',
      actionText: 'Ik informeer me eerst om Senait te helpen de juiste beslissing te nemen:',
      actions: [
        // {
        //   type: 'button',
        //   key: 'button-watch-1',
        //   text: 'Ik bekijk het interview met Jonas, directeur van het centrum voor Niet begeleide minderjarige vreemdelingen (NBMV’s)',
        //   buttonStyle: { '&:hover': { color: colors.pink } },
        //   icon: boutonRegarder,
        //   iconHover: boutonRegarderHoover,
        //   action: 'openDialog',
        //   dialogContent: {
        //     transition: 'slideUp',
        //     type: 'video',
        //     videoIframe: getYoutubeIframe('895ZbYG3O3U'),
        //   },
        // },
        {
          type: 'button',
          key: 'button-ask',
          text: 'Ik vraag aan Senait: ‘Wat zegt je hart?’',
          buttonStyle: { '&:hover': { color: colors.pink } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: 'openDialog',
          dialogContent: {
            type: 'image',
            imageSrc: PhylactereMaman,
            imageStyle: { marginBottom: '15vh', width: '30vw', maxWidth: '400px', height: 'auto', maxHeight: '50vh', objectFit: 'contain', objectPosition: 'center' },
          },
        },
      ],
      nextButtonStyle: {
        '&:hover': { color: colors.pink },
      },
      nextButtonText: 'Neem een beslissing >',
      nextStepId: 'choice final',
    },
    {
      id: 'choice final',
      type: 'choice',

      ...base_choice_style,
      contentText:
        'Nu sna<span class="background-underlined very-large">p je mijn dilemma</span>. Wat zou jij in mijn plaats doen?<br/>Start je, ondanks het gevaar, de pro<span class="background-underlined very-large">cedure waarmee mijn moeder en broert</span>jes mogelijks naar België kunnen komen? Of <span class="background-underlined large">neem je dit risico niet</span>?',
      choices: [
        {
          type: 'button',
          key: 'button-1',
          text: 'De procedure starten om mijn familie te laten komen',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title:
              'Weet je <span class="background-underlined medium">dat zeker</span>? Ik zou het <span class="background-underlined very-large">mezelf nooit vergeven</span> als er hen iets overkomt',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue final 1',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
        {
          type: 'button',
          key: 'button-2',
          text: 'Het risico niet nemen',
          buttonStyle: choiceButtonStyle,
          action: 'showConfirmation',
          confirmationContent: {
            title: 'Weet je <span class="background-underlined medium">dat zeker</span>? Ik kan me niet <span class="background-underlined large">voorstellen dat ik hen nooit</span> meer zou zien...',
            buttons: [
              {
                text: 'Ja, ik ben er zeker van',
                buttonStyle: choiceButtonStyle,
                action: 'goNext',
                nextStepId: 'epilogue final 2',
              },
              {
                text: 'Ik neem een<br/>andere beslissing',
                buttonStyle: choiceButtonStyle,
                action: 'closeConfirmation',
              },
            ],
          },
        },
      ],
    },
    {
      id: 'epilogue final 1',

      ...base_epilogue,

      // sound: SENAIT_FR_EPILOGUE_FINAL1,
      // sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Dit is hoe ons leven eruitziet in België...',
          // text: 'Na een lange procedure zijn mijn moeder en mijn broertjes eindelijk hier! Wat heerlijk, wat een opluchting … Mijn moeder is blij dat we weer allemaal samen zijn, maar ze vindt het jammer dat het niet gelukt is om mijn vader uit de gevangenis te krijgen. We hebben nog steeds geen nieuws over hem.<br/>Ik heb eindelijk mijn diploma van de middelbare school en ik kan nu verpleegkunde gaan studeren. Daar heb ik altijd van gedroomd! <br/>De repressie in Eritrea blijft aanhouden. Er zijn ook drama’s in Libië en op de Middellandse Zee. Ik denk aan iedereen die minder geluk heeft gehad en ik voel me vreselijk geprivilegieerd. Mijn moeder heeft gelijk, ondanks alles wat ik heb meegemaakt, heb ik een engelbewaarder.',
          textStyle: { left: '45vw' },
        },
      ],
      // nextStepId: 'other_choices',
      nextStepId: "-1",
    },
    //55
    {
      id: 'epilogue final 2',

      ...base_epilogue,

      // sound: SENAIT_FR_EPILOGUE_FINAL2,
      // sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: 'Dit is hoe mijn leven eruitziet in België...',
          // text: 'Ik heb eindelijk mijn diploma van de middelbare school en ik kan verpleegkunde studeren. Mijn Nederlands is vrij goed geworden en ik werk nu ook als tolk. Ik heb ook een paar goeie vrienden. Ik probeer blij te zijn met alles wat er gebeurt, ook al heb ik het gevoel dat ik mijn familie in de steek heb gelaten. En ook over mijn vader is er nog steeds geen nieuws.<br/>Duizenden mensen lijden onder de repressie in Eritrea of het geweld onderweg. Ik denk aan hen en ik weet hoeveel geluk ik heb dat ik vrij en veilig ben.',
          textStyle: { left: '45vw' },
        },
      ],
      // nextStepId: 'other_choices',
      nextStepId: "-1",
    },
    // {
    //   id: 'mapIncoherence1',
    //   type: 'map',
    //   background: baseBackgroundImg,
    //   mapImage: mapIncoherence1,
    //   mapImageStyle: { maxWidth: '1500px', width: '80vw', height: 'auto' },
    //   mapContainerClass: 'cursor-gray',
    //   nextStepDelay: 3500,
    //   nextStepId: 'SENAIT 12',
    // },
    {
      id: 'mapIncoherence2',
      type: 'map',
      background: baseBackgroundImg,
      mapImage: mapIncoherence2,
      mapImageStyle: { maxWidth: '1500px', width: '80vw', height: 'auto' },
      mapContainerClass: 'cursor-gray',
      nextStepDelay: 3500,
      nextStepId: 'epilogue tente',
    },
  ],
};
